import { Component } from '@angular/core';
import { UIService } from '../core/services/utils/ui.service';

@Component({
    selector: 'greyout',

    template:
        `<div *ngIf="uiService.isGreyoutVisible" class="overlay-grey" (click)="uiService.hideGreyout()">
    <h1>Server connection lost</h1> <h2>Please, refresh the page to establish server connection</h2>
     </div>`,

    styles: [`
    .overlay-grey{
        background-color: rgba(2,2,2,.6);
        position: absolute;
        z-index: 1000000;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        color: rgba(255,255,255,.8);
        text-align: center;
        padding-top:10%;
    }

    h1{
        font-size: 71px;
    }

    h2{
        font-size: 39px;
    }`]
})

export class GreyoutComponent {
    constructor(public uiService: UIService) { }
}
